<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_hour_cost">每小时{{pricing.labor_hour_cost | numeral('$0,0.00')}}</div>
        </a>

        <a class="weui-cell" href="javascript:;" v-if="pricing.stairs_cost">
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.stairs_cost">{{pricing.stairs_cost | numeral('$0,0.00')}} </span>
              <span v-if="pricing.stairs_cost==0">无</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.return_trip_cost">约 {{pricing.return_trip_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="pricing.weight_cost">
            <div class="weui-cell__bd">
                <p>重物费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.weight_cost">{{pricing.weight_cost | numeral('$0,0.00')}}</span>
              <span v-if="pricing.weight_cost==0">无</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="order.data.move_other_valuables">
            <div class="weui-cell__bd">
                <p>重物费（其他重物）</p>
            </div>
            <div class="weui-cell__ft">
              <span>需现场评估确定费用</span>
            </div>
        </a>
        <!-- 
        <a class="weui-cell" href="javascript:;" v-if="order.data.insurance_amount">
            <div class="weui-cell__bd">
                <p>保险费</p>
            </div>
            <div class="weui-cell__ft">
              <span>{{this.order.data.insurance_amount| numeral('$0,0.00')}}</span>
            </div>
        </a>
        -->
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">
              <span>总费用10%</span>
            </div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="park-assist" @click="editData(vehicle_id)"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p>
            </div>
        </label>
      </div>
      <div class="weui-cells__title">优惠券</div>
      <div class="weui-cells coupon-cell">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title | uppercase}}</div>
            <div class="weui-cell__ft" v-else> <span class="icon-coupon"></span> 点击使用 </div>
        </a>
      </div>

      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells active">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step1')">
            <div class="weui-cell__bd">
                <p>搬家规模</p>
            </div>
            <div class="weui-cell__ft">{{move_scale}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step2')">
            <div class="weui-cell__bd">
                <p>搬家车型</p>
            </div>
            <div class="weui-cell__ft">{{move_car}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step5')">
            <div class="weui-cell__bd">
                <p>搬家时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step4')">
            <div class="weui-cell__bd">
                <p>贵重物品</p>
            </div>
            <div class="weui-cell__ft">{{ move_valuables ? move_valuables : '无' }}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step3/out')">
            <div class="weui-cell__bd">
                <p>搬出地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.move_out_street}}, {{order.data.move_out_suburb}}, {{order.data.move_out_state}}, {{order.data.move_out_postcode}}<br>{{toTextFloor(order.data.move_out_floor)}} {{toTextParking(order.data.move_out_parking)}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step3/wp?wpKey='+index)" v-for="(item, index) in order.data.pathway_address"> 
            <div class="weui-cell__bd">
                <p>途经点 {{order.data.pathway_address.length>1 ? index+1 : ''}}</p>
            </div>
            <div class="weui-cell__ft"><span v-show="item.unit">{{item.unit}}, </span>{{item.street}}, {{item.suburb}}, {{item.state}}, {{item.postcode}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/move-step3/in')">
            <div class="weui-cell__bd">
                <p>搬入地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.move_in_street}}, {{order.data.move_in_suburb}}, {{order.data.move_in_state}}, {{order.data.move_in_postcode}}<br>{{toTextFloor(order.data.move_in_floor)}} {{toTextParking(order.data.move_in_parking)}}</div>
        </a>
      </div>
      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>
      <div class="weui-cells__title">中介推荐码</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="如果由中介推荐，请输入中介推荐码" v-model="order.data.agency">
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="showModal=true">创建订单</div>
        </div>
      </div>


      <transition name="fade">
        <v-modal v-show="showModal" @close="showModal = false">
          <div slot="body">
            <div class="modal-title">到家搬家服务协议</div>
            <div style="font-size:0.9em;">
              到家将竭尽全力保证搬家过程中物品的完好。但请您务必检查搬家物品、家具家电、墙面、门、走廊等所有服务相关物品是否在搬家过程中造成了损坏，<span class="color-orange">如有损坏，请在24小时内联系客服处理。</span>如超出时限，我们将<span class="color-orange">不予受理</span>，敬请谅解！
              <br><br>
              冰箱、洗衣机等家电，在服务结束后静置4小时再通电试运行，外观或外包装没有明显磕碰痕迹的情况下，电器内部运行或功能问题，不在售后受理范围。敬请谅解！<br><br>
            </div>
            <div class="btn-box">
              <div class="btn mgt10 active" @click="Order()">我已阅读并同意服务协议</div>
            </div>
          </div>
        </v-modal>
      </transition>
      
      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      
      <img :src="pixelURL('move','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSendingPricing:false,
      pricing:{},
      showModal:false
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/move-step6';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        //this.$router.push('/move-insurance');
        this.$router.push('/move-step5');
      }
    },

    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735905;

        orderObject.vehicle_type = this.dataLint("move_car",orderObject.move_car);
        orderObject.move_in_floor = this.dataLint("floor",orderObject.move_in_floor);
        orderObject.move_out_floor = this.dataLint("floor",orderObject.move_out_floor);

        for (let item in orderObject.move_valuables) {
          if(orderObject.move_valuables[item]==0){
            delete orderObject.move_valuables[item];
          }
        }
        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },
    Order(){
      this.showModal = false;

      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency)
        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735905;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.move_out_name;
            orderObject.member_phone = orderObject.move_out_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");

        orderObject.move_car = this.dataLint("move_car",orderObject.move_car);
        orderObject.move_scale = this.dataLint("move_scale",orderObject.move_scale);
        orderObject.move_in_floor = this.dataLint("floor",orderObject.move_in_floor);
        orderObject.move_out_floor = this.dataLint("floor",orderObject.move_out_floor);
        orderObject.move_in_parking = this.dataLint("parking",orderObject.move_in_parking);
        orderObject.move_out_parking = this.dataLint("parking",orderObject.move_out_parking);


        for(let key in orderObject.pathway_address){
          if(orderObject.pathway_address[key].unit.length>0){
            orderObject.pathway_address[key].street = orderObject.pathway_address[key].unit +", "+ orderObject.pathway_address[key].street;
          }
        }


        for (let item in orderObject.move_valuables) {
          if(orderObject.move_valuables[item]==0){
            delete orderObject.move_valuables[item];
          }
        }

        orderObject['vehicle_type'] = orderObject['move_car'];
        delete orderObject['move_car'];
        
        orderObject['order_source'] = '3';

        //     途经点floor parking数据备用
        //     for (var i=0;i<orderObject.pathway_address.length;i++){
        //       orderObject.pathway_address[i].move_wp_floor = this.dataLint("floor",orderObject.pathway_address[i].move_wp_floor);
        //       orderObject.pathway_address[i].move_wp_parking = this.dataLint("parking",orderObject.pathway_address[i].move_wp_parking);
        //     }


        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('savedMove');
            localStorage.removeItem('order');

            localStorage.is_questions = response.data.data.is_questions;
            localStorage.phone_question = orderObject.member_phone;
            localStorage.questions = JSON.stringify(response.data.data.questions);

            if(response.data.data.accoun_status>=0){ //已登录购买
              localStorage.account_status = response.data.data.accoun_status;
            }

            if(response.data.data.accoun_status == 2){ //没注册
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
            
            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount());

          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
    dataLint(name,value){
      let result ="";

      if (name == "move_scale"){
        switch (value) {
          case "1":
            result = "1556849081"
            break;
          case "2":
            result = "1556849088"
            break;
          case "3":
            result = "1556849093"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "move_car"){
        switch (value) {
          case "1":
            result = "1551345549"
            break;
          case "2":
            result = "1552463010"
            break;
          case "3":
            result = "1551345539"
            break;
          case "4":
            result = "1551686190"
            break;
          case "5":
            result = "1557383838"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "parking") {
        switch (value) {
          case "1":
            result = "1551410080"
            break;
          case "2":
            result = "1551410087"
            break;
          case "3":
            result = "1551410093"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1":
            result = "1551412462"
            break;
          case "2":
            result = "1551412475"
            break;
          case "3":
            result = "1551412486"
            break;
          case "4":
            result = "1551412499"
            break;
          case "5":
            result = "1551412509"
            break;
          case "6":
            result = "1551412525"
            break;
          case "7":
            result = "1551412535"
            break;
          default:
            console.log("7");
        }
      }
      return result;
    },

    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '已预留Loading Dock'
          break;
        case "2":
          result = '已预留停车位'
          break;
        case "3":
          result = '无停车位'
          break;
        default:
          console.log("9");
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '有电梯/住G层'
          break;
        case "2":
          result = '1层 无电梯'
          break;
        case "3":
          result = '2层 无电梯'
          break;
        case "4":
          result = '3层 无电梯'
          break;
        case "5":
          result = '4层 无电梯'
          break;
        case "6":
          result = '5层 无电梯'
          break;
        case "7":
          result = '5层以上 无电梯'
          break;
        default:
          console.log("8");
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    vehicle_id : function () {
      return "/move-vehicle?v="+this.order.data.move_car;
    }, 
    move_scale: function () {
      let result = '';
      switch (this.order.data.move_scale) {
        case "1":
          result = '个人搬家'
          break;
        case "2":
          result = '小型整屋'
          break;
        case "3":
          result = '大型整屋'
          break;
        default:
          console.log("2");
      }
      return result;
    },
    move_car: function () {
      let result = '';
      switch (this.order.data.move_car) {
        case "1":
          result = '小面包车'
          break;
        case "2":
          result = '小型箱货'
          break;
        case "3":
          result = '中型箱货'
          break;
        case "4":
          result = '大型箱货'
          break;
        case "5":
          result = '特大箱货'
          break;
        default:
          console.log("3");
      }
      return result;
    },

    move_valuables: function () {
      let result = '';
      let concatResult = '';
      let obj = this.order.data.move_valuables;
      for (let item in obj) {
        switch (item) {
          case "1551417471":
            result = '保险箱'
            break;
          case "1551417480":
            result = '钢琴'
            break;
          case "1551417486":
            result = '玻璃易碎品'
            break;
          case "1551417492":
            result = '三门实木衣柜'
            break;
          case "1551418035":
            result = '跑步机'
            break;
          case "1551418043":
            result = '按摩椅'
            break;
          case "1551418054":
            result = '大理石制品'
            break;
          case "1663575190":
            result = '商用打印机'
            break;
          case "1663575217":
            result = '商用冰柜'
            break;
          case "1663575258":
            result = '其他易碎品'
            break;
          case "1663575412":
            result = '麻将机'
            break;
          case "1663575433":
            result = '实木家具'
            break;
          case "1663575454":
            result = '双开门冰箱'
            break;
          default:
            console.log("4");
        }
        if(obj[item]>0){
          concatResult = concatResult+result+' ';
        }
      }
      if(typeof this.order.data.move_other_valuables != "undefined"){
        concatResult = concatResult+this.order.data.move_other_valuables;
      }
      return concatResult;
    }
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedMove){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedMove;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "move"){
          localStorage.order = localStorage.savedMove;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
        this.userCatch("1550735905",this.order.data.move_out_name,this.order.data.move_out_phone,true);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}


.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }
  .weui-cell_access .weui-cell__ft:after{
    border-color: #FE956A;
  }
  .modal-container{
    width: 94vw;
    padding: 0px 20px 20px 20px;
    margin: 0px auto 40px auto;
  }
  .btn{
    margin-top:20px;
  }
  .icon-x{
    margin-right:10px;
  }
  .modal-title{
    margin-bottom:10px;
  }
  .btn{
    height:44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/move/step6.vue